interface Log {
  file: string
  message: string
  level?: 'info' | 'error'
  error?: unknown
}

export function log({ file, message, level = 'error', error }: Log): void {
  console.table({
    level,
    file,
    message,
    ...(error !== undefined ? { error } : {}),
  })
}
